// next-app/src/lib/env.ts

/**
 * Type-safe environment configuration
 * All NEXT_PUBLIC_ variables are available on both server and client
 */
export const env = {
  // API
  apiUrl: process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000/dealers/',
  environment: process.env.NEXT_PUBLIC_ENV || 'development',

  // Error Monitoring
  bugsnagApiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY || '',

  // Feature Flags
  enableDemoPages: process.env.NEXT_PUBLIC_ENABLE_DEMO_PAGES === 'true',

  // Computed values
  isDevelopment: process.env.NEXT_PUBLIC_ENV === 'development',
  isStaging: process.env.NEXT_PUBLIC_ENV === 'staging',
  isProduction: process.env.NEXT_PUBLIC_ENV === 'production',
} as const;

// Validate required environment variables
export function validateEnv(): void {
  const required = ['NEXT_PUBLIC_API_URL'];
  const missing = required.filter((key) => !process.env[key]);

  if (missing.length > 0) {
    console.warn(`Missing environment variables: ${missing.join(', ')}`);
  }
}
